/**
 * Maps the given object to it's unbound property.
 * @param {string} property Name of the property to be extracted
 */
export const get = property => object => object[property]

/**
 * Wraps the given field <any> inside an object, assigning it to the given
 * property name.
 * @param {string} property Name to be assigned.
 */
export const put = property => field => ({ [property]: field })
